if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setupNavigation();
        this.showActiveMedia();
      }

      setupNavigation() {
        if (this.navigationReady) return;
        this.navigationReady = true;
        const navigationButtons = this.querySelectorAll('[data-media-step]');
        const hasMultipleMedia = this.querySelectorAll('.product-media-modal__content > [data-media-id]').length > 1;
        navigationButtons.forEach((button) => {
          button.hidden = !hasMultipleMedia;
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', () => this.changeMedia(Number(button.dataset.mediaStep)));
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.changeMedia(-1);
          if (event.key === 'ArrowRight') this.changeMedia(1);
        });
      }

      async changeMedia(step) {
        if (this.mediaChanging) return;
        const mediaItems = [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
        if (mediaItems.length < 2) return;
        const currentIndex = mediaItems.findIndex((media) => media.classList.contains('active'));
        const nextIndex = (currentIndex + step + mediaItems.length) % mediaItems.length;
        this.mediaChanging = true;
        this.querySelectorAll('[data-media-step]').forEach((button) => (button.disabled = true));
        try {
          await this.prepareMedia(mediaItems[nextIndex]);
          this.activateMedia(mediaItems[nextIndex]);
          this.preloadAdjacentMedia(mediaItems, nextIndex);
        } finally {
          this.querySelectorAll('[data-media-step]').forEach((button) => (button.disabled = false));
          this.mediaChanging = false;
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.activateMedia(activeMedia);
        const mediaItems = [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
        this.preloadAdjacentMedia(mediaItems, mediaItems.indexOf(activeMedia));

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }

      async prepareMedia(media) {
        const image = media.nodeName === 'IMG' ? media : media.querySelector('img');
        if (!image) return;
        image.loading = 'eager';
        image.fetchPriority = 'high';
        if (image.complete && image.naturalWidth) return;
        try {
          await image.decode();
        } catch {
          await Promise.race([
            new Promise((resolve) => {
              image.addEventListener('load', resolve, { once: true });
              image.addEventListener('error', resolve, { once: true });
            }),
            new Promise((resolve) => setTimeout(resolve, 5000)),
          ]);
        }
      }

      preloadAdjacentMedia(mediaItems, currentIndex) {
        if (mediaItems.length < 2 || currentIndex < 0) return;
        [-1, 1, 2].forEach((offset) => {
          const media = mediaItems[(currentIndex + offset + mediaItems.length) % mediaItems.length];
          const image = media.nodeName === 'IMG' ? media : media.querySelector('img');
          if (!image) return;
          image.loading = 'eager';
          image.decode().catch(() => {});
        });
      }

      activateMedia(activeMedia) {
        if (!activeMedia) return;
        const items = [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
        const position = this.querySelector('[data-sp-current]');
        const total = this.querySelector('[data-sp-total]');
        if (position) position.textContent = String(items.indexOf(activeMedia) + 1);
        if (total) total.textContent = String(items.length);
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((media) => {
          media.classList.toggle('active', media === activeMedia);
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
